import { createSlice } from "@reduxjs/toolkit";
import { LoaderState } from "../../models/store/loaderState";

const initialState: LoaderState = {
  isLoaderOpen: false,
  isSidebarLoaderOpen: false,
};

const loaderSlice = createSlice({
  name: "loader",
  initialState,
  reducers: {
    showLoader: (state) => {
      state.isLoaderOpen = true;
    },
    hideLoader: (state) => {
      state.isLoaderOpen = false;
    },
    showSidebarLoader: (state) => {
      state.isSidebarLoaderOpen = true;
    },
    hideSidebarLoader: (state) => {
      state.isSidebarLoaderOpen = false;
    },
  },
});

export const { showLoader, hideLoader, showSidebarLoader, hideSidebarLoader } =
  loaderSlice.actions;

export default loaderSlice.reducer;
